import './retentionWidget.scss'
import {
    AnalyticsSelectors,
    RetentionTable,
    RetentionChart,
} from '@/features/analytics'
import { Title } from '@/shared/ui'
import { useInviteLinksStore } from '@/features/analytics/model'
import { useGroupNameChannels } from '../../invite-links/hooks/useGroupName'
import { Link } from 'react-router'
import {
    useActiveWorkspace,
    workspacePath,
    Channel,
} from '@/true-fsd/data/advertiser-account'

export type RetentionWidgetProps = {
    groupId: number
    activeChannel: Channel
}
export const RetentionWidget = ({
    activeChannel,
    groupId,
}: RetentionWidgetProps) => {
    const {
        startDateRetention,
        endDateRetention,
        usersSortRetention,
        subscriberStatusSortRetention,
        trafficSourceSortRetention,
        detalizationSortRetention,
        setStartDateRetention,
        setEndDateRetention,
        setTrafficSourceSortRetention,
        setDetalizationSortRetention,
        setUsersSortRetention,
        setSubscriberStatusSortRetention,
    } = useInviteLinksStore()

    const groupName = useGroupNameChannels({
        channelId: activeChannel.channel_id,
    })

    const { activeWorkspace } = useActiveWorkspace()

    return (
        <div className="retention-widget">
            <div>
                <Title className="title">Удержание подписчиков</Title>
                <div className="retention-widget__link">
                    <div className="link">
                        <Link
                            to={workspacePath(
                                activeWorkspace,
                                `analytics/retention`
                            )}
                            className="campaigns-link"
                        >
                            Группы
                        </Link>
                    </div>
                    {'     '}/ {groupName}
                </div>
            </div>

            <AnalyticsSelectors
                trafficSource={trafficSourceSortRetention}
                detalization={detalizationSortRetention}
                users={usersSortRetention}
                subscribers={subscriberStatusSortRetention}
                datePicker={{
                    startDate: startDateRetention,
                    endDate: endDateRetention,
                }}
                onTrafficSourceSelect={setTrafficSourceSortRetention}
                onDetalizationSelect={setDetalizationSortRetention}
                onUsersSelect={setUsersSortRetention}
                onSubscribersSelect={setSubscriberStatusSortRetention}
                onDateChange={{
                    onFromDateChange: setStartDateRetention,
                    onToDateChange: setEndDateRetention,
                }}
                mode="Retention"
            />

            <RetentionChart channelId={activeChannel.channel_id} />
            <RetentionTable groupId={groupId} activeChannel={activeChannel} />
        </div>
    )
}
